<template>

    <div class="lesson_page" v-if="englishProgramLesson != null">
        <div class="main_content" ref="mainContent">

            <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation">
                <div :style="{height:getStateHeight()+'px'}"></div>
                <div class="left" @click="goToBack">
                    <div class="left_back">
                        <img src="@/Images/icon_white_back.png"/>
                    </div>
                </div>
                <div class="clear"></div>
            </div>

            <div class='video_content'>
                <video-player class="video-player vjs-custom-skin"
                              ref="videoPlayer"
                              :playsinline="true"
                              :options="playerOptions"
                              @play="onPlayerPlay($event)"
                               @ended="onPlayerEnded($event, 1)">
                </video-player>
            </div>
            <div class="page-navbar">
                <mt-navbar class="page-part" v-model="selected">
                    <mt-tab-item id="1" :style="parseInt(selected) === 1 ? isSelected() : {cursor: 'pointer'}">互动课</mt-tab-item>
                    <mt-tab-item id="2" :style="parseInt(selected) === 2 ? isSelected() : {cursor: 'pointer'}">介绍</mt-tab-item>
                    <mt-tab-item id="3" :style="parseInt(selected) === 3 ? isSelected() : {cursor: 'pointer'}">评论 {{englishProgramLesson.newCommentCount > 0 ? englishProgramLesson.newCommentCount : ''}}</mt-tab-item>
                </mt-navbar>
                <div class="sty_tab_container">
                    <mt-tab-container v-model="selected">
                        <mt-tab-container-item id="1">
                            <div class="top_space">
                                <div class="lesson">
                                    <div class="basic_info">
                                        <div class="english_title">
                                            <div class="title">{{englishProgramLesson.name}}</div>
                                        </div>
                                        <div class="des">
                                            <div class="des" v-if="!isEmpty(englishProgramLesson.subject)">
                                                <div class="des_name"></div>
                                                <div class="des_text"><span>主题</span>：{{englishProgramLesson.subject}}</div>
                                                <div class="clear"></div>
                                            </div>
                                            <div class="des_name"></div>
                                            <div class="des_text"><span>听力词汇</span>：{{englishProgramLesson.coreWords}}</div>
                                            <div class="clear"></div>
                                            <div class="des" v-if="!isEmpty(englishProgramLesson.sentencePattern)">
                                                <div class="des_name"></div>
                                                <div class="des_text"><span>积累词汇量</span>：{{englishProgramLesson.wordCount}}/1000</div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                        <div class="clear"></div>
                                    </div>

                                    <div class="course_explain_bg" v-if="!isEmpty(englishProgramLesson.explanationVideo)" @click="explainClick">
                                        <div class="course_explain">
                                            <div class="course_explain_title">
                                                <img src="@/assets/player_play.png" alt="" />
                                                <span>绘本分页精讲</span>
                                            </div>

                                            <div class="course_explain_img">
                                                <img src="@/Images/icon_picture_book.png" alt="" />
                                            </div>
                                        </div>
                                        <div class="clear"></div>
                                    </div>

                                    <!-- 详细信息展示 -->
                                    <div class="lesson_detail">
                                        <div class="split_title">
<!--                                            <div class="video_title">-->
<!--                                                <div class="left_line"></div>-->
<!--                                                <div class="title_back"><span>互动课程</span></div>-->
<!--                                                <div class="right_line"></div>-->
<!--                                            </div>-->
                                        </div>

                                        <!-- 练一练 -->
                                        <!--                    <div class="exercise">-->
                                        <!--                        <div class="title">练一练</div>-->
                                        <!--                        <div class="unpurchase" v-if="englishProgramLesson.isBuy === 0" @click="buyProgram"><span>¥{{englishProgramLesson.price}}</span>购买{{englishProgramLesson.buyLessonCount}}节课-->
                                        <!--                            <img src="@/assets/chevron-right.png"/></div>-->
                                        <!--                    </div>-->

                                        <div class="lesson_action_j">
                                            <!-- warm up, speaking -->
                                            <div class="row_entry">
                                                <div class="entry entry_margin" @click="warmUpClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_warm_up.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Warm Up</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="englishProgramLesson.warmUpFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>

                                                <div class="entry margin_left30" @click="speakingClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_speaking.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Speaking</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="englishProgramLesson.speakingFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- game, family time -->
                                            <div class="row_entry">
                                                <div class="entry entry_margin" @click="gameClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_game.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Game</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="englishProgramLesson.gameFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>

                                                <div class="entry margin_left30" @click="familyTimeClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_famliy_time.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Family Time</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="englishProgramLesson.familyTimeFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="bottom_space"></div>
                                    </div>
                                </div>
                            </div>
                        </mt-tab-container-item>
                        <mt-tab-container-item id="2">
                            <div class="top_space">
                                <div class="top_space">
                                    <div class="lesson">
                                        <div class="lesson_detail">
                                            <div class="intro_content">
                                                <pre id="div_intro_content" class="content">{{englishProgramLesson.courseIntroduction}}</pre>
                                            </div>

                                            <div class="view_time margin_top40" v-if="!isEmpty(englishProgramLesson.watchFrequency)">
                                                <div class="backgroud_title">观看Tips</div>
                                                <div class="backgroud_content">
                                                    <pre>{{englishProgramLesson.watchFrequency}}</pre>
                                                </div>
                                            </div>

                                            <div class="split"></div>

                                            <div class="qrcode_title">课程咨询群</div>
                                            <div class="icon_qrcode">
                                                <img src="@/Images/icon_qrcode.png" alt="" />
                                            </div>
                                            <div class="qrcode_des">
                                                长按下图保存，进入微信识别<br/>咨询课程信息、使用建议
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mt-tab-container-item>
                        <mt-tab-container-item id="3">
                            <div class="top_space">
                                <div class="top_space">
                                    <div class="lesson">
                                        <div class="lesson_detail">
                                            <!-- 我们这么玩儿 -->
                                            <div class="remark">
<!--                                                <div class="title">{{englishProgramLesson.commentCount > 0 ? englishProgramLesson.commentCount +-->
<!--                                                    " " : ""}}评论-->
<!--                                                </div>-->
                                                <div class="hot_new" v-show="false">
                                                    <div :class="sort === 1 ? 'selected' : 'unselected'" @click="hotClick">按热度</div>
                                                    <div class="v_line"><span>｜</span></div>
                                                    <div :class="sort !== 1 ? 'selected' : 'unselected'" @click="sortByTime">按时间</div>
                                                </div>
                                                <div v-if="englishProgramLesson.newCommentCount > 0" class="i_say" @click="iSayClick">
                                                    <img src="@/Images/icon_pencil.png"/><span>我来说说</span>
                                                </div>
                                            </div>

                                            <!-- 无内容提示 -->
                                            <div class="no_data" v-if="englishProgramLesson.newCommentCount === 0">说说，这节课的使用感受或反馈...</div>

                                            <!-- 我来说说 -->
                                            <div v-if="englishProgramLesson.newCommentCount === 0" class="i_say_no" @click="iSayClick">
                                                <img src="@/Images/icon_pencil.png"/><span>我来说说</span>
                                            </div>

                                            <!-- 无内容空距 -->
                                            <div class="no_data_space" v-if="englishProgramLesson.newCommentCount === 0"></div>
                                            <!-- 内容展示 -->
                                            <div class="remark_data">
                                                <div v-for="(itemRemark,index) in listRemark" :key="'info1-'+ index">
                                                    <!-- 头部信息 -->
                                                    <div class="user_head">
                                                        <div class="head" @click="enterSpace(itemRemark.userId)"><img alt=''
                                                                                                                      :src='geneUserHead(itemRemark.userId, itemRemark.userPicture)'/>
                                                        </div>
                                                        <div class="name_child">
                                                            <div class="user_name" @click="enterSpace(itemRemark.userId)">
                                                                {{itemRemark.userName}}
                                                            </div>
                                                            <div class="child">
                                                                <div class="child_list" v-for="(item,index1) in itemRemark.childDataArray"
                                                                     :key="index1">
                                                                    <div v-if="index1 < 2">
                                                                        <img :src='geneSexImage(item.daughterOrSon)'/><span>{{item.ageDisplay}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="do_more" v-if="itemRemark.userId === userId"
                                                             @click="removeClick(itemRemark.pk)"><img src="@/Images/icon_more.png" alt=""/>
                                                        </div>
                                                        <div class="clear"></div>
                                                    </div>
                                                    <!-- 内容信息 -->
                                                    <div class="content_info">
                                                        <!-- 文字内容 -->
                                                        <div v-if="!isEmpty(itemRemark.content)" class="word">
                                                            <pre>{{itemRemark.content}}</pre>
                                                        </div>
                                                        <!-- 图片 -->
                                                        <div v-if="!isEmpty(itemRemark.pictureInfoArray)" class="picture">
                                                            <div v-for="(itemPicture,index2) in itemRemark.pictureInfoArray"
                                                                 :key="'info2-'+ index2">
                                                                <img :src="getWholeThumbnailCut(itemPicture.fileName, 200, 200)" alt=""
                                                                     @click="showPicture(itemRemark.pk,index2)"/>
                                                            </div>
                                                        </div>

                                                        <!-- 时间、回复入口 -->
                                                        <div class="time_reply">
                                                            <div class="time">
                                                                {{itemRemark.createTimeDisplayString}}
                                                            </div>
                                                            <div class="reply" @click="replyClick(itemRemark.pk)">
                                                                <img src="@/Images/icon_reply.png"><span>回复</span>
                                                            </div>
                                                        </div>
                                                        <!-- 回复详细信息 -->
                                                        <div class="comment_list" v-if="!isEmpty(itemRemark.commentArray)"
                                                             @click="replyClick(itemRemark.pk)">
                                                            <div class="comment" v-for="(itemComment,index3) in itemRemark.commentArray"
                                                                 :key="index3">
                                                                <span>{{itemComment.userName}}</span>:{{itemComment.content}}
                                                            </div>
                                                            <div class="more_comment"
                                                                 v-if="itemRemark.commentCount > itemRemark.commentArray.length">查看全部
                                                                {{itemRemark.commentCount}} 条回复
                                                            </div>
                                                            <div class="no_more" v-else></div>
                                                        </div>
                                                        <div class="clear"></div>
                                                    </div>

                                                    <!-- 分隔线 -->
                                                    <div class="line"></div>
                                                </div>

                                                <div class="load_more" v-if="!loadFinish && haveLoadData" @click="loadMoreData">点击加载更多...</div>
                                                <div class="load_finish" v-if="loadFinish && !isEmpty(listRemark)">加载完毕</div>
                                            </div>
                                            <mt-actionsheet
                                                    :actions="actions"
                                                    v-model="flag">
                                            </mt-actionsheet>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mt-tab-container-item>
                    </mt-tab-container>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {MessageBox, Toast} from "mint-ui";
    import Vue from "vue";
    import {videoPlayer} from 'vue-video-player'
    import 'vue-video-player/src/custom-theme.css'
    import 'video.js/dist/video-js.css'
    import Utils from '@/pages/Program/util2.js';

    export default {
        components: {
            videoPlayer
        },
        data() {
            return {
                selected: '1',
                courseId: 0,
                lessonId: 0,
                userId: 0,
                englishProgramLesson: null,
                progress: 0,
                isPlay: false,
                isFold: false,
                currentTime: 0,
                mTimer: null,
                listRemark: [],
                loadFinish: false,
                haveLoadData: false,
                flag: false,
                actions: [],
                sort: 1,
                offset: 0,
                limit: 10,
                deleteId: 0,
                popupVisible: false,
                playerOptions: {
                    //播放速度
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: ''
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                },
                playerOptions1: {
                    //播放速度
                    // playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: ''
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                },
            }
        },
        watch : {
            selected(newV){
                if (parseInt(newV) === 3) {
                    this.hotClick();
                }
            }
        },
        methods: {
            goToBack() {
                this.isFold = false;
                window.PLessonScrollTop = 0;
                this.goBack(this.$router);
            },
            isSelected() {
                return {
                    color: '#ff5050',
                    'border-bottom': '3px solid #ff5050',
                    cursor: 'pointer'
                };
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            onPlayerPlay: function (e) {
                //此方法不可以在异步方法中执行
                if (e.requestFullscreen) {
                    e.requestFullscreen();
                } else if(e.mozRequestFullScreen) {
                    e.mozRequestFullScreen();
                } else if(e.msRequestFullscreen) {
                    e.msRequestFullscreen();
                } else if(e.oRequestFullscreen) {
                    e.oRequestFullscreen();
                } else if(e.webkitRequestFullscreen) {
                    e.webkitRequestFullScreen();
                }
            },
            onPlayerEnded: function (e, type) {
                if (type === 2) {
                    if (e.exitFullscreen){
                        e.exitFullscreen();
                    } else if (e.webkitExitFullscreen) {
                        e.webkitExitFullscreen()
                    }
                    return;
                }

                let that = this;
                let url = "englishProgram/updateUserViewCount/" + that.lessonId;
                this.$axios.get(url).then((response) => {
                    if (response.data === 1) {
                        if (e.exitFullscreen){
                            e.exitFullscreen();
                        } else if (e.webkitExitFullscreen) {
                            e.webkitExitFullscreen()
                        }
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            changeStart: function () {
                let that = this;
                that.isPlay = !that.isPlay;
                const musicMp3 = document.getElementById('musicMp3');
                if (that.isPlay) {
                    if (that.mTimer == null) {
                        that.changeProgress();
                    }
                    musicMp3.play()
                } else {
                    if (musicMp3 != null) {
                        musicMp3.pause();
                    }
                }
            },
            changeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3');

                if (musicMp3 != null) {
                    that.mTimer = setInterval(() => {
                        const numbers = musicMp3.currentTime / musicMp3.duration;
                        let perNumber = (numbers * 100).toFixed(2);
                        if (perNumber >= 100) {
                            that.isPlay = false;
                            that.progress = 0;
                            that.currentTime = 0;
                            clearInterval(that.mTimer);
                            that.mTimer = null;
                        } else {
                            that.progress = perNumber;
                            that.currentTime = musicMp3.currentTime;
                        }
                    }, 50);
                }
            },
            callChangeProgress: function () {
                let that = this;
                const musicMp3 = document.getElementById('musicMp3');

                if (musicMp3 != null) {
                    musicMp3.pause();
                }

                that.changeProgress()
            },
            packageClick: function () {
                let that = this;

                if (this.isAppIos()) {
                    document.location = "readingclubapp:singleAudioPackage:" + that.englishProgramLesson.audioPackageId;
                }

                if (this.isAppAndroid()) {
                    window.note.singleAudioPackage(that.englishProgramLesson.audioPackageId);
                }
            },
            buyProgram: function () {
                let that = this;
                let vPlatform = that.judgePlatform();
                let vYouZanUrl = this.englishProgramLesson.buyUrl.replace(new RegExp('https:', 'g'), '');

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:buyProgramCourse:" + that.courseId + ":" + vYouZanUrl;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.buyProgramCourse(that.courseId, that.englishProgramLesson.buyUrl);
                }
            },
            mustBuy: function () {
                let that = this;
                let isBuy = that.englishProgramLesson.isBuy;
                let freeTrial = that.englishProgramLesson.freeTrial;

                if (isBuy === 0 && freeTrial === 0) {
                    MessageBox.confirm('', {
                        message: ' ',
                        title: '要先购买才能上课哦～快去购买吧！',
                        showConfirmButton: false,
                        showCancelButton: true,
                        closeOnClickModal: false,
                        cancelButtonClass: 'cancelButton',
                        confirmButtonClass: 'confirmButton',
                        cancelButtonText: '知道了'
                    });
                    return true;
                }

                return false;
            },
            explainClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                that.viewLog();
                this.$router.push({name: "PVideo", query: {lessonId: this.lessonId}});
            },
            viewLog:function () {
                let that = this;
                let url = "englishProgram/addExpansionVideoViewLog/" + that.lessonId;

                that.$axios.get(url).then((response) => {}).catch(function (error) {
                    window.console.log(error)
                });
            },
            warmUpClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.$router.push({name: "PWarmUp", query: {lessonId: this.lessonId, hasReview:
                        that.englishProgramLesson.hasPreviousLessonReview, audioId: that.englishProgramLesson.audioId}});
            },
            speakingClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.$router.push({name: "PCoreWord", query: {lessonId: this.lessonId}});
            },
            gameClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.$router.push({name: "PGameHome", query: {lessonId: this.lessonId}});
            },
            familyTimeClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.$router.push({name: "PFamilyTime", query: {lessonId: this.lessonId}});
            },
            enterSpace: function (userId) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:enterSpace:" + userId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.enterSpace(userId);
                }
            },
            hotClick: function () {
                let that = this;
                that.sort = 1;
                that.loadNewData();
            },
            sortByTime: function () {
                let that = this;
                that.sort = 2;
                that.loadNewData();
            },
            loadNewData: function () {
                let that = this;
                that.offset = 0;
                that.haveLoadData = false;
                that.loadFinish = false;
                let url = "englishProgram/getLessonComment2/" + that.lessonId + "/0/" + that.limit;

                this.$axios.get(url).then((response) => {
                    let programLesson = response.data;
                    that.listRemark = programLesson.commentList;
                    that.englishProgramLesson.newCommentCount = programLesson.newCommentCount;
                    that.haveLoadData = true;
                    that.loadFinish = that.listRemark != null && that.listRemark.length < that.limit;
                    that.offset = that.isEmpty(that.listRemark) ? 0 : that.listRemark.length;
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            loadMoreData: function () {
                let that = this;
                let url = "englishProgram/getLessonComment2/" + that.lessonId + "/" + that.offset + "/" + that.limit;

                this.$axios.get(url).then((response) => {
                    let programLesson = response.data;
                    let listData = programLesson.commentList;
                    that.listRemark = that.listRemark.concat(listData);
                    that.haveLoadData = true;
                    that.loadFinish = listData != null && listData.length < that.limit;
                    that.offset = that.isEmpty(that.listRemark) ? 0 : that.listRemark.length;
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            iSayClick: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:writeComment:" + that.lessonId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.writeComment(parseInt(that.lessonId));
                }
            },
            replyClick: function (pk) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:writeReply:" + pk + ":" + that.lessonId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.writeReply(pk, that.lessonId);
                }
            },
            showPicture(pk, index) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:showPicture:" + pk + ":" + index;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.showPicture(pk, index);
                }
            },
            removeClick: function (pk) {
                this.deleteId = pk;
                this.flag = true;
            },
            removeConfirm: function () {
                let that = this;
                let url = "englishProgram/deleteLessonComment2/" + that.deleteId;

                this.$axios.get(url).then((response) => {
                    if (response.data === 1) {
                        Toast('删除成功');
                        that.deleteId = 0;
                        that.loadNewData();
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            refreshOneRow: function (pk) {
                let that = this;
                let url = "englishProgram/getSingleLessonComment2/" + pk;

                this.$axios.get(url).then((response) => {
                    if (!that.isEmpty(response.data)) {
                        for (var i = 0; i < that.listRemark.length; i++) {
                            let commentItem = that.listRemark[i];

                            if (commentItem.pk === pk) {
                                Vue.set(that.listRemark, i, response.data);
                            }
                        }
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            buyCourseSuccess: function () {
                let that = this;
                that.englishProgramLesson.isBuy = 1;
            },
            showStatus: function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            setStarCount:function (type) {
                // type 1亲子PK/2亲子合作对话/3词汇/4词卡游戏/5语言游戏/6认知游戏/7上节课Review/8歌词
                let that = this;
                let vType = parseInt(type);
                let url = "englishProgram/setFinishPart3/" + that.lessonId + "/" + vType;

                that.$axios.get(url).then((response) => {
                    let vLesson = response.data;

                    if (vLesson !== null) {
                        if (vLesson.finish === 1) {
                            Utils.$emit('setLessonFinish', that.lessonId);
                        }

                        that.englishProgramLesson.warmUpFinish = vLesson.warmUpFinish;
                        that.englishProgramLesson.speakingFinish = vLesson.speakingFinish;
                        that.englishProgramLesson.gameFinish = vLesson.gameFinish;
                        that.englishProgramLesson.familyTimeFinish = vLesson.familyTimeFinish;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            }
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatus(0);
            });
        },
        beforeRouteLeave(to, from, next) {
            if (to.name !== "PAfter") {
                window.PLessonScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            }

            this.showStatus(1);
            next();
        },
        mounted: function () {
            let that = this;
            that.actions = [{name: "删除", method: that.removeConfirm}];
            that.callChangeProgress();
            window.PLessonScrollTop = 0;
            
            Utils.$on('setStarCount', function (type) {
                that.setStarCount(type);
            });
        },
        activated() {
            window.scrollTo(0, window.PLessonScrollTop);
        },
        created() {
            let that = this;

            // 客户端调用方法组
            window.sortByTime = that.sortByTime;
            window.refreshOneRow = that.refreshOneRow;
            window.buyCourseSuccess = that.buyCourseSuccess;
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "englishProgram/getLessonHomeInfo/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.englishProgramLesson = response.data;
                that.lessonId = vlessonId;
                that.listRemark = []; // that.englishProgramLesson.commentList;
                that.haveLoadData = false;
                that.loadFinish = false; // that.listRemark != null && that.listRemark.length < 10;
                that.offset = that.isEmpty(that.listRemark) ? 0 : that.listRemark.length;
                that.userId = parseInt(that.$store.state.userid.toString());

                let vedioUrl = that.$qiNiuDomainBase + that.englishProgramLesson.video;
                that.playerOptions.poster = vedioUrl + "?vframe/jpg/offset/5";
                that.playerOptions.sources[0].src = vedioUrl;

                setTimeout(function () {
                    that.hideStatusAndStopAudio();
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>

    .navigation .left_back {
        width: 34px;
        height: 34px;
        background-color: #0000005a;
        border-radius: 17px;
        margin-left: 16px;
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .navigation .left .left_back img {
        width: 26px;
        height: 26px;
        margin-right: 2px;
    }

    .main_content {
        width: 100%;
        height: 56.25vmin;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2222;
    }

    .main_content .left {
        position: absolute;
        z-index: 2223;
        float: left;
        width: 50px;
        height: 44px;
        color: white;
        font-size: 25px;
        text-align: center;
        line-height: 50px;
    }

    .video_content {
        display: inline-block;
        width: 100%;
        height: 56.25vmin;
        background: white;
    }

    .course_explain_bg {
        width: 100%;
        background-color: white;
        margin-top: 50px;
        padding-bottom: 120px;
    }
    .course_explain {
        width: 310px;
        height: 170px;
        position: relative;
        top: 128px;
        box-shadow: 0 -2px 0 0 #e5e5e5,   /*上边阴影 */
        -2px 0 0 0 #e5e5e5,   /*左边阴影  */
        3px 0 0 0 #e5e5e5,    /*右边阴影 */
        0 3px 0 0 #e5e5e5;    /*下边阴影 */
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        font-size: 0;
    }
    .course_explain_title {
        position: absolute;
        left: 10px;
        top: 10px;
        display: flex;
        align-items: center;
    }
    .course_explain_title img {
        width: 25px;
        height: 25px;
    }
    .course_explain_title span {
        margin-left: 10px;
        color: #333333;
        font-size: 17px;
        font-weight: bold;
    }

    .course_explain_img {
        position: absolute;
        bottom: 20px;
        left: 0;
        right: 0;
        display: flex;
        font-size: 0;
        justify-content: center;
        text-align: center;
    }
    .course_explain_img img {
        width: 100px;
        height: 100px;
    }

    .top_space {
        position: fixed;
        width: 100%;
        height: calc(100vmax - 56.25vmin - 58px);
        top: calc(56.25vmin + 60px);
        right: 0;
        bottom: 0;
        left: 0;
    }

    .lesson_page {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
        text-align: center;
    }

    .lesson {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 997;
        display: inline-block;
        text-align: -webkit-center;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .basic_info {
        float: left;
        width: 100%;
        color: #333333;
        background-color: white;
        padding-top: 20px;
        font-size: 15px;
        text-align: left;
    }

    .basic_info .english_title {
        display: flex;
    }
    .basic_info .english_title .title {
        margin-left: 15px;
        margin-right: 105px;
        margin-bottom: 3px;
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        word-wrap: break-word;
        word-break: normal;
    }
    .basic_info .english_title .course_intro {
        position: absolute;
        width: 80px;
        height: 30px;
        right: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 15px;
        border: 1px solid #e5e5e5;
    }
    .basic_info .english_title .course_intro img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
    }
    .basic_info .english_title .course_intro span {
        color: #666666;
        font-size: 13px;
    }

    .basic_info .des {
        display: inline-block;
        position: relative;
        margin-top: 5px;
    }

    .basic_info .des .des_name {
        float: left;
        background-color: #ff505a;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        margin-left: 15px;
        margin-right: 10px;
        margin-top: 3px;
    }

    .basic_info .des_text {
        width: calc(100vmin - 50px);
        color: #666666;
        font-size: 15px;
        margin-left: 30px;
        margin-right: 15px;
        line-height: 18px;
        font-family: Arial;
        word-wrap: break-word;
        word-break: normal;
        white-space: pre-wrap;
    }
    .basic_info .des_text span {
        color: #333333;
    }

    .lesson_detail {
        width: 100%;
        min-height: 100%;
        background-color: white;
        text-align: left;
    }

    .lesson_detail .detail_title {
        width: calc(100% - 30px);
        margin-left: 15px;
        margin-right: 15px;
        padding-top: 20px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        word-wrap: break-word;
        word-break: normal;
    }

    pre {
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
    }

    .split_title {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 15px;
    }
    .lesson_detail .remark {
        width: 100%;
        display: inline-block;
        margin-top: 20px;
    }

    .lesson_detail .exercise .title, .lesson_detail .remark .title {
        float: left;
        margin-left: 15px;
        font-size: 16px;
        color: #333333;
    }

    .lesson_detail .remark .hot_new {
        float: left;
        margin-left: 15px;
        display: inline-block;
    }

    .lesson_detail .exercise .unpurchase span {
        color: #ff5050;
        margin-right: 5px;
    }

    .lesson_detail .exercise .unpurchase img {
        height: 18px;
        vertical-align: middle;
    }

    .lesson_detail .lesson_action_j {
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .lesson_detail .lesson_action_j .row_entry {
        width: 100%;
        display: inline-flex;
        margin-bottom: 50px;
    }
    .lesson_detail .lesson_action_j .entry {
        width: 140px;
        height: 155px;
        text-align: center;
        position: relative;
    }
    .lesson_detail .lesson_action_j .entry_margin {
        margin-left: calc((100vmin - 310px)/2.0);
    }
    .lesson_detail .lesson_action_j .margin_left30 {
        margin-left: 30px;
    }
    .lesson_action_j .entry .back_entry {
        width: 140px;
        height: 140px;
        box-shadow: 0 -2px 0 0 #e5e5e5,   /*上边阴影 */
                    -2px 0 0 0 #e5e5e5,   /*左边阴影  */
                    3px 0 0 0 #e5e5e5,    /*右边阴影 */
                    0 3px 0 0 #e5e5e5;    /*下边阴影 */
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        font-size: 0;
    }
    .lesson_detail .lesson_action_j .icon {
        width: 75px;
        margin-top: 10px;
    }
    .lesson_action_j .entry_title {
        height: 40px;
    }
    .lesson_action_j .entry_title span {
        line-height: 40px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }
    .lesson_detail .lesson_action_j .finish_flag {
        position: absolute;
        bottom: 0;
        left: 50%;
        -webkit-transform: translateX(-50%);
        display: flex;
    }
    .lesson_detail .lesson_action_j .finish_flag img {
        width: 30px;
        height: 30px;
    }



    .lesson_detail .lesson_action_j .icon_flag {
        position: relative;
    }

    .lesson_detail .split {
        width: 100%;
        height: 10px;
        background-color: #f4f4f4;
    }

    .lesson_detail .dashed {
        border: 0.8px dashed #999;
        height: 1px;
        margin-top: 20px;
    }

    .lesson_detail .no_data {
        width: 100%;
        text-align: center;
        margin-top: 100px;
        font-size: 15px;
        color: #999999;
    }

    .lesson_detail .i_say {
        display: inline-flex;
        float: right;
        width: 120px;
        height: 25px;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }

    .lesson_detail .i_say_no {
        display: inline-flex;
        width: 70vmin;
        height: 40px;
        margin-left: 15vmin;
        margin-right: 15vmin;
        margin-top: 15px;
        margin-bottom: 30px;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }

    .lesson_detail .i_say_no img, .lesson_detail .i_say img {
        width: 16px;
        height: 16px;
        margin-right: 3px;
    }

    .lesson_detail .i_say_no span, .lesson_detail .i_say span {
        color: #ff5050;
        font-size: 15px;
    }

    .lesson_detail .no_data_space {
        height: 180px;
    }

    .remark_data .user_head {
        margin-top: 15px;
    }

    .remark_data .user_head .head {
        float: left;
        display: flex;
    }

    .remark_data .user_head .head img {
        width: 40px;
        height: 40px;
        margin-left: 15px;
        margin-right: 10px;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }

    .remark_data .user_head .name_child {
        float: left;
    }

    .remark_data .user_head .name_child .user_name {
        color: #333333;
        font-size: 15px;
        margin-bottom: 1px;
    }

    .remark_data .user_head .name_child .child_list {
        display: inline-flex;
    }

    .remark_data .user_head .name_child .child_list img {
        width: 12px;
    }

    .remark_data .user_head .name_child .child_list span {
        color: #999999;
        font-size: 14px;
        margin-left: 3px;
        margin-right: 8px;
    }

    .remark_data .user_head .do_more {
        float: right;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .remark_data .user_head .do_more img {
        margin-right: 15px;
        width: 20px;
    }

    .remark_data .content_info {
        margin-left: 65px;
        margin-top: 10px;
    }

    .remark_data .content_info .word {
        margin-right: 15px;
        color: #333333;
        font-size: 16px;
    }

    .remark_data .content_info .picture {
        display: flex;
        margin-right: 5px;
        margin-top: 10px;
        flex-wrap: wrap;
    }

    .remark_data .content_info .picture img {
        width: calc((100vmin - 100px) / 3);
        height: calc((100vmin - 100px) / 3);
        margin-right: 10px;
        margin-bottom: 5px;
    }

    .remark_data .content_info .time_reply {
        width: calc(100vmin - 65px);
        display: inline-block;
        margin-top: 10px;
    }

    .remark_data .content_info .time_reply .time {
        float: left;
        color: #999999;
        font-size: 14px;
    }

    .remark_data .content_info .time_reply .reply {
        float: right;
        padding-left: 5px;
        padding-right: 5px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .remark_data .content_info .time_reply .reply img {
        width: 15px;
        height: 15px;
    }

    .remark_data .content_info .time_reply .reply span {
        color: #999999;
        font-size: 14px;
        margin-left: 5px;
    }

    .remark_data .content_info .comment_list {
        background-color: #f3f3f3;
        margin-top: 15px;
        margin-right: 15px;
    }

    .remark_data .content_info .comment_list .comment {
        font-size: 14px;
        color: #666666;
        margin-left: 10px;
        margin-right: 10px;
        padding-top: 5px;
    }

    .remark_data .content_info .comment_list .comment span {
        color: #6a7ba0;
    }

    .remark_data .content_info .comment_list .more_comment {
        font-size: 14px;
        color: #6a7ba0;
        margin-left: 10px;
        margin-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .remark_data .content_info .comment_list .no_more {
        padding-top: 5px;
    }

    .remark_data .line {
        margin-top: 15px;
        height: 1px;
        background-color: #f5f5f5;
    }

    .remark_data .load_more, .remark_data .load_finish {
        width: 100%;
        height: 50px;
        background-color: #e5e5e5;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
    }

    .popup_style {
        width: calc(100% - 30px);
        max-height: calc(100vmax - 56.25vmin - 100px);
        margin-top: calc((100vmax - 112.5vmin - 100px) / 2.0);
        overflow-y: auto;
        padding: 20px 15px;
        margin-right: 25px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        z-index: 9999;
    }

    .popup_style pre {
        text-align: left;
        font-size: 17px;
        color: #333333;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .qrcode_title {
        width: 100%;
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-top: 30px;
    }
    .icon_qrcode img {
        width: 50vmin;
        margin-left: 25vmin;
        margin-top: 30px;
    }
    .qrcode_des {
        width: 100%;
        color: #999999;
        font-size: 13px;
        text-align: center;
        margin-top: 5px;
        padding-bottom: 120px;
    }
    .view_time {
        width: calc(100% - 30px);
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 20px;
        color: #333333;
        font-size: 15px;
        text-align: left;
    }

    .intro_content {
        text-align: left;
        margin-left: 15px;
        margin-right: 15px;
        padding-top: 20px;
    }
    .intro_content .content {
        color: #333333;
        font-size: 16px;
        line-height: 25px;
        text-align: left;
    }

    .backgroud_title {
        margin-top: 5px;
        color: #333333;
        font-size: 16px;
    }
    .backgroud_content {
        margin-top: 10px;
        color: #333333;
        font-size: 16px;
    }
    .bottom_space {
        height: 100px;
    }
    .margin_top40 {
        margin-top: 40px;
    }

</style>
